import { Button as MetxButton } from "@mm/metx-design-system";
import { type ComponentPropsWithoutRef, forwardRef } from "react";

export type ButtonProps = ComponentPropsWithoutRef<typeof MetxButton>;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => <MetxButton {...props} ref={ref} />);

Button.displayName = "Button";
